<template>
  <div>
    <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-[100]">
      <transition
        enter-active-class="ease-out duration-200"
        leave-active-class="ease-out duration-100"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-if="showModal" class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75" @click="closeModal"></div>
        </div>
      </transition>

      <transition
        enter-active-class="ease-out duration-200"
        leave-active-class="ease-out duration-100"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-if="showModal"
          id="modal"
          class="max-h-[95%] bg-white relative rounded-lg overflow-y-auto shadow-xl transform transition-all sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <!-- <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div> -->
              <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                <h3 id="modal-headline" class="text-lg leading-6 font-medium text-gray-900">
                  {{ title }}
                </h3>
                <div class="mt-2">
                  <p class="text-sm leading-5 text-gray-500">
                    {{ body }}
                  </p>
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 rounded-b-lg px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span v-if="!cancelOnly" class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <TButton :label="action" :color="actionColor == 'red' ? actionColor : 'indigo'" @click="handleAction">
                <LocalLoadingSpinner />
              </TButton>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <TButton label="Cancel" color="white" @click="closeModal" />
            </span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {},
  props: ['title', 'body', 'action', 'actionColor', 'cancelOnly'],
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    this.showModal = true;
    document.addEventListener('keydown', e => {
      if (this.showModal && e.keyCode == 27) {
        this.closeModal();
      }
    });
  },
  methods: {
    closeModal() {
      const self = this;
      self.showModal = false;
      setTimeout(function () {
        self.$emit('closeModal');
      }, 200);
    },
    handleAction() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      self.$emit('handleAction');
    },
    success() {
      const self = this;
      this.loadingSpinnerStore.hideLocalLoadingSpinner();
      self.showModal = false;
      setTimeout(function () {
        self.$emit('closeModal');
      }, 200);
    },
    error() {
      this.loadingSpinnerStore.hideLocalLoadingSpinner();
    },
  },
};
</script>
